import { pushDatalayer } from '@shared/Frontend/seo/datalayer'
import { cn } from '@shared/Frontend/utils/addToClassName'
import { Clickable } from '@shared/Frontend/utils/clickable'
import React from 'react'

type PageheaderAction = { external: boolean; url: string; label: string }

type PageheaderActionsProps = {
  primaryAction?: PageheaderAction
  secondaryAction?: PageheaderAction
  isHome: boolean
}

export const PageheaderActions = ({ primaryAction, secondaryAction, isHome }: PageheaderActionsProps) => {
  if (!primaryAction && !secondaryAction) return null

  return (
    <div className="ph__footer ls-clickables">
      {primaryAction && (
        <div className="ls-clickable">
          <Clickable
            elementKind="link"
            styleKind="button"
            {...primaryAction}
            className="ph__clickable button"
            hasBlob={true}
            icon={'icon-chevron-right'}
            onClick={() => {
              pushDatalayer({
                category: 'default_pageheader',
                action: 'primary_button_click',
                label: primaryAction.label.toLowerCase(),
              })
            }}
          />
        </div>
      )}
      {secondaryAction && (
        <div className="ls-clickable">
          <Clickable
            elementKind="link"
            styleKind="link"
            {...secondaryAction}
            className={cn('ph__clickable link', isHome ? 'link--hollow' : 'link--filled')}
            hasBlob={true}
            icon={'icon-chevron-right'}
            onClick={() => {
              pushDatalayer({
                category: 'default_pageheader',
                action: 'secondary_button_click',
                label: secondaryAction.label.toLowerCase(),
              })
            }}
          />
        </div>
      )}
    </div>
  )
}
